import { render, staticRenderFns } from "./PosReportSales.vue?vue&type=template&id=7dda57b4&"
import script from "./PosReportSales.vue?vue&type=script&lang=js&"
export * from "./PosReportSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports